/* eslint-disable security/detect-object-injection */
import React, { useEffect, useState } from 'react';
import { dataService } from '../../../services/data.service';
import ChoiceSection from '../../../components/ChoiceSection';
import { documentsLanguageContent } from '../documentsLanguageContent';
import './styles.css'
import HandleUI from '../handleComponentUI';
import { isSubset } from '../../../helpers/CommonFunctions';

function ViewComponents(props) {
    const { formData, selectedLanguage, setDataDocumentPercent, pages, setPages, droppedComponents, setDroppedComponents, selectedChoice, setSelectedChoice, componentAnswers, setComponentAnswers } = props;
    const [components, setComponenents] = useState([]);
    const [show, setShow] =  useState('');
    const [pageLoading, setPageLoading] = useState(true);

    const getAllComponents = (components, nextToken) => {
        dataService.GetPatientComponents(formData.form_id, formData.version_id, nextToken).then((res) => {
            let tempComponents = [...components, ...res.data.data]
            setComponenents(tempComponents);
            if(components.length === 0) {
                setPageLoading(false);
                setDataDocumentPercent((prev) => ({
                    ...prev,
                    total_components_count: res.data.total_components_count,
                    completed_components_count: res.data.completed_components_count,
                    incomplete_required_fields: res.data.incomplete_required_fields
                }))
            }
            if(res.data.next_token) {
                getAllComponents(tempComponents, res.data.next_token);
            }
        })
    }

    useEffect(() => {
        getAllComponents([], '')
    }, []);

    const checkVisibility = (components) => {
        let updatedComponents = [];
        components.forEach((component_data, index) => {
            if (!component_data.is_dependent) {
                return { ...component_data, show: true, dependent_configuration: { ...component_data.dependent_configuration} };
            }
      
            const logicalOperator = component_data.dependent_configuration.operator || 'AND';
            let allConditionsTrue = false
            let anyConditionTrue = false
            if(logicalOperator === 'AND'){
                allConditionsTrue = component_data.dependent_configuration.conditions.every((condition) => {
                    const dependentComponent = components.find((comp) => comp.component_id === condition.component_id);
                    if (dependentComponent) {
                        const dependentValue = dependentComponent.type === 'checkbox' ? dependentComponent.values : dependentComponent.value;
                        const conditionalValue = condition.values;
                        switch (condition.operator) {
                        case '==':
                        case 'IN':
                            if(dependentComponent.type === 'checkbox'){
                                return isSubset(conditionalValue, dependentValue)
                            }else{
                                return dependentValue === conditionalValue[0]
                            }
                        case '!=':
                        case 'NOT IN':
                            if(dependentComponent.type === 'checkbox'){
                                return !isSubset(conditionalValue, dependentValue)
                            }else{
                                return dependentValue !== conditionalValue[0];
                            }
                        default:
                            return true; // Default to true if no operator is specified
                        }
                    } else {
                        // If a dependent component is not found, the condition is not met.
                        return false;
                    }
                });
            }
            if(logicalOperator === 'OR'){
                anyConditionTrue = component_data.dependent_configuration.conditions.some((condition) => {
                    const dependentComponent = components.find((comp) => comp.component_id === condition.component_id);
                    if (dependentComponent) {
                        const dependentValue = dependentComponent.values;
                        const conditionalValue = condition.values;
                        switch (condition.operator) {
                        case '==':
                        case 'IN':
                            if(dependentComponent.type === 'checkbox'){
                                return isSubset(conditionalValue, dependentComponent.values)
                            }else{
                                return dependentValue[0] === conditionalValue[0];
                            }
                        case '!=':
                        case 'NOT IN':
                            if(dependentComponent.type === 'checkbox'){
                                return !isSubset(conditionalValue, dependentComponent.values)
                            }else{
                                return dependentValue[0] !== conditionalValue[0];
                            }
                        default:
                            return true; // Default to true if no operator is specified
                        }
                    } else {
                        // If a dependent component is not found, the condition is not met.
                        return false;
                    }
                });
            }

            const shouldShow = logicalOperator === 'AND' ? allConditionsTrue : logicalOperator === 'OR' ? anyConditionTrue : false;
            let tempComponentData = components[index]
            //push to updatedcomponents array if any elements are updated
            if(tempComponentData['show'] !== shouldShow || tempComponentData['value'] !== component_data.value || tempComponentData['values'].join(', ') !== component_data.values.join(', ')) {
                let componentObject = {
                    component_id: tempComponentData.component_id,
                    show: shouldShow
                }
                if(tempComponentData.type === 'checkbox') {
                    componentObject['values'] = shouldShow ? component_data.values : []
                } else {
                    componentObject['value'] = shouldShow ? component_data.value : ''
                }
                updatedComponents.push(componentObject)
            }
            tempComponentData['show'] = shouldShow;
            tempComponentData['values'] = shouldShow ? component_data.values : [];
            tempComponentData['value'] = shouldShow ? component_data.value : '';
            components[index] = tempComponentData
            setComponenents([...components])
            // setTimeout(() => {
            //     if(pages[component_data.page]) {
            //         const componentIndex = (pages[component_data.page].components).findIndex(obj => obj.component_id === component_data.component_id);
            //         pages[component_data.page].components[componentIndex]['value'] = shouldShow ? component_data.value : '';
            //         pages[component_data.page].components[componentIndex]['values'] = shouldShow ? component_data.values : [];
            //         setPages([...pages]);
            //         droppedComponents[component_data.page] = pages[component_data.page];
            //         setDroppedComponents([...droppedComponents])
            //     }
            // }, [2500])
            if(component_data.type === 'checkbox') {
                componentAnswers[component_data.component_id] = shouldShow ? component_data.values : [];
            } else {
                componentAnswers[component_data.component_id] = shouldShow ? component_data.value : '';
            }  
        });
        if(updatedComponents.length > 0) {
            dataService.UpdateDocumentComponentInBatch(updatedComponents, formData.form_id, formData.version_id);
        }
    };

    
    return (
        pageLoading ?
            <div className='overflow-auto h-[calc(100vh-360px)]'>
                {[...Array(5)].map((item, index) => (
                    <div key={index} className='my-4'>
                        <div className='w-1/2 animate-pulse rounded-lg  h-[20px] bg-slate-300' />
                        <div className='w-full animate-pulse rounded-lg h-[20px] bg-slate-300 mt-2' />
                    </div>
                ))}
            </div>
            :
            <div
                className=" overflow-x-auto Form-scroll px-2 h-[calc(100vh-395px)]">
                {components.map((item , index) => (
                    (item.show === true ||  item.show === undefined) &&
                    <div key={`component-${item.component_id}`} className={`border-b border-[#D7D7D7] pb-6 mt-[24px]`}>
                        {<HandleUI components={components} setComponenents={setComponenents} formData={formData} checkVisibility={checkVisibility} pages={pages} setPages={setPages}
                            component={item} show={show} setShow={setShow} componentIndex={index} setDataDocumentPercent={setDataDocumentPercent}
                            droppedComponents={droppedComponents} setDroppedComponents={setDroppedComponents} componentAnswers={componentAnswers} setComponentAnswers={setComponentAnswers}
                        />}
                    </div>
                ))}
                <>
                    <p className={`text-[#333333] text-sm font-normal ${selectedLanguage === 'ar' ? 'text-end' : 'text-justify'} pt-[24px] pb-[16px]`}>
                        {documentsLanguageContent['acknowledge'][selectedLanguage]}</p>
                    <div className='flex justify-center items-center mb-4'>
                        <img src="/images/form-required.svg" alt="required" className='mr-2 mt-2' />
                        <div>
                            <p className='text-center text-sm font-normal' />
                            <div className='flex mt-[12px] justify-center'>
                                <div onClick={() => setSelectedChoice('Yes')} data-testid={`acknowledge_Yes`}
                                    className={`flex ${selectedChoice === 'Yes' ? 'bg-[#007EB4] text-[#F2F2F2]' : 'text-[#333333]'} cursor-pointer justify-center gap-[12px] rounded-l-[47px] border border-[#333] items-center px-[30px] py-[8px]`}>
                                    <p className={`font-normal text-sm`}>Yes</p>
                                </div>
                                <div onClick={() => setSelectedChoice('No')} data-testid={`acknowledge_No`} className={`flex ${selectedChoice === 'No' ? 'bg-[#007EB4] text-[#F2F2F2]' : 'text-[#333333]'} cursor-pointer justify-center gap-[12px] rounded-r-[47px] 
                        border border-[#333] items-center px-[30px] py-[8px]`}>
                                    <p className={`font-normal text-sm`}>No</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            </div>
            
    );
}

export default ViewComponents;